<template>
<v-card class='mb-3'>
  <v-img :aspect-ratio="16/9" height=150 v-if='value' :src='imgUrl' >
    <v-card-title @click='showdialog=true' >
      <v-btn >Change</v-btn>
      <v-spacer></v-spacer>
      <help-popover color='white' >
        We'll use this image on your website and in general when we want to make your appointment types look nice
      </help-popover>
    </v-card-title>
  </v-img>
  <v-card-title v-else class='subheading' >
    <v-btn absolute right  @click='showdialog=true' >Choose one</v-btn>
    No background image<br/>
    <small class='hidden-xs-only' style='max-width:80%;'>
      We'll use this image on your website and in general when we want to make your appointment types look nice
    </small>
  </v-card-title>
  <v-dialog fullscreen v-model='showdialog' >
    <v-card flat>
      <v-toolbar dense flat >
        <v-toolbar-title>Choose a background picture</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click='showdialog=false' icon ><v-icon>close</v-icon></v-btn>
      </v-toolbar>
      <v-card-text>
        <image-search
          v-model='imgUrl'
          title='Search for an image'
          @close='showdialog=false' ></image-search>
      </v-card-text>
    </v-card>
  </v-dialog>
  <v-alert v-if='errorMessages && errorMessages.length > 0' type='error' :value='true' class='pt-0 pb-1' >
    <ul>
      <li v-for='err in errorMessages' :key='err' v-text='err' ></li>
    </ul>
  </v-alert>
</v-card>
</template>

<script>
import HelpPopover from '@/components/ui/HelpPopover'
import ImageSearch from '@/components/ui/ImageSearch'
export default {
  name: 'BackgroundSelector',
  components: {HelpPopover, ImageSearch},
  props: {
    value: { type: String, required: true, default: '' },
    errorMessages: { type: Array, default: () => { return [] } }
  },
  data () {
    return {
      showdialog: false,
      imgUrl: null
    }
  },
  watch: {
    value: {
      immediate: true,
      handler () {
        this.imgUrl = this.value
      }
    },
    imgUrl () {
      this.$emit('input', this.imgUrl)
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// BackgroundSelector.vue?0da7d437